import React from 'react';
import getOrderError from '../../logic/GetOrderError';
import Alert from '../shared/Alert';
import SupportDetails from '../shared/SupportDetails';

type Props = {
  error: any;
};

const OrderFormErrors = ({ error }: Props) =>
  error.exists() && (
    <div id="test-error">
      <Alert variant={error.isFatal() ? 'error' : 'warn'}>
        <p className="text14 mb-3">
          <span>
            {error.isFatal()
              ? error.getMessage()
              : getOrderError(error.getMessage())}
          </span>{' '}
          <SupportDetails />
        </p>
      </Alert>
    </div>
  );

export default OrderFormErrors;
